import { render } from "./LogisticsTypeSet.vue?vue&type=template&id=c158ab74&scoped=true&ts=true"
import script from "./LogisticsTypeSet.vue?vue&type=script&lang=ts"
export * from "./LogisticsTypeSet.vue?vue&type=script&lang=ts"

import "./LogisticsTypeSet.vue?vue&type=style&index=0&id=c158ab74&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c158ab74"]])

export default __exports__